export default {
  seat: {
    parenthesis: '({{text}})',
    header: {
      station: 'ご購入情報を入力してください。',
      seat: '座席を選択してください。',
      start: '{{time}}発',
      seatConfirm: '座席確認',
      reserveConfirm: '予約内容確認',
      changeConfirm: '予約変更内容確認',
      bookingConfirm: '※決済完了かつ予約完了後に正式確保となります。'
    },
    button: {
      back: '戻る',
      prev: '前へ',
      next: '次へ',
      change: '変更'
    },
    selectSeatType: {
      title: '座席選択方式',
      auto: '自動割り当て',
      manual: '手動選択'
    },
    station: {
      date: '乗車日',
      startStation: '乗車駅',
      endStation: '降車駅',
      selectTip: '{{name}}を選択してください。'
    },
    train: {
      header: '列車を選択してください。',
      emptySeat: '空席',
      wheelchairAvailable: '車椅子スペース利用可',
      wheelchairUnavailable: '車椅子スペース利用不可',
      noTrains: '購入可能な列車がございません。運行情報をご確認ください。',
      trainLabel: '{{trainName}}{{trainServiceNo}}号'
    },
    carriage: {
      carriageCar: '{{carNo}}号車',
      directionUpTitle: '↑ 宇奈月方面',
      directionDownTitle: '↑ 欅平方面',
      conductor: '車掌席'
    },
    wheelchairConfirm: {
      title: '車椅子専用スペースをご選択されました。',
      content: 'このスペースは車椅子のお客様専用です。',
      notice1: '2スペースごとにお手伝い1名様までご利用いただけます。',
      confirmText: 'このまま選択を続けますか？',
      cancel: 'キャンセル',
      confirm: 'はい'
    },
    confirmCommon: {
      noticeTitle: '座席の確認',
      notice1: '※予約完了 または 変更手続き完了後に正式確保になります。',
      notice2: '座席はまだ確保されておりません',
      outbound: '往路',
      inbound: '復路',
      seatLine: '{{carNo}}号車-{{seatNo}}',
      departureStation: '{{station}}発',
      arrivalStation: '{{station}}着'
    },
    confirmChange: {
      instruction: '内容に問題がなければ「変更」を押してください。',
      contentLabel: '変更内容',
      before: '変更前',
      after: '変更後',
      noChange: '変更なし'
    },
    confirmReserve: {
      contentLabel: '予約内容'
    }
  },
  error: {
    // doto: 別の言語に展開する
    invalidParams:
      'ご指定の条件に誤りがあります。お手数ですが、最初からやり直してください。',
    invalidDate: '選択できない日付です。',
    lineIdInvalid:
      '路線が選択されていません。お手数ですが、最初からやり直してください。',
    productIdInvalid:
      '選択した商品が不正です。お手数ですが、最初からやり直してください。',
    forbidden:
      'この操作は許可されていません。お手数ですが、最初からやり直してください。',
    notUpdatable:
      'この予約は現在変更できません。お手数ですが、最初からやり直してください。',
    notFound:
      '指定されたページが見つかりません。お手数ですが、最初からやり直してください。',
    notFoundTitle: 'お探しのページは見つかりませんでした。',
    notFoundDescription: 'URLが正しいかご確認ください。',
    systemError:
      'システムエラーが発生しました。しばらく経ってから再度お試しください。'
  }
};
